import React from 'react';
import { Box, Container, Paper, Typography, IconButton } from '@mui/material';
import { Minimize, CropSquare, Close } from '@mui/icons-material';

const AuthPageLayout = ({
  children,
  containerMaxWidth = 'sm',
  paperMaxWidth = 480,
  paperSx,
  showDesktopHeader = false,
}) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: (theme) =>
          theme.palette.mode === 'dark'
            ? theme.palette.background.default
            : `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
        py: { xs: 2, sm: 3 },
        px: 2,
      }}
    >
      <Container maxWidth={containerMaxWidth} disableGutters>
        <Paper
          elevation={18}
          sx={{
            width: '100%',
            maxWidth: paperMaxWidth,
            mx: 'auto',
            p: 0,
            borderRadius: showDesktopHeader ? 2 : 3,
            position: 'relative',
            overflow: 'hidden',
            ...paperSx,
          }}
        >
          {showDesktopHeader && (
            <Box
              sx={{
                backgroundColor: 'primary.main',
                color: 'primary.contrastText',
                p: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderRadius: '8px 8px 0 0',
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: 500, ml: 1 }}>
                FigShelf - Figure Collection Manager
              </Typography>
              <Box sx={{ display: 'flex' }}>
                <IconButton size="small" sx={{ color: 'inherit', p: 0.5 }}>
                  <Minimize fontSize="small" />
                </IconButton>
                <IconButton size="small" sx={{ color: 'inherit', p: 0.5, mx: 0.5 }}>
                  <CropSquare fontSize="small" />
                </IconButton>
                <IconButton size="small" sx={{ color: 'inherit', p: 0.5 }}>
                  <Close fontSize="small" />
                </IconButton>
              </Box>
            </Box>
          )}
          <Box sx={{ p: { xs: 2.5, sm: 3 } }}>
            {children}
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default AuthPageLayout;
